import * as React from "react"
import { SVGProps } from "react"
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="transparent"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.68699 11.437L2.99999 9.75L1.31299 11.437"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.312 12.562L21 14.25L22.688 12.562"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21 14.25V12C21 7.03 16.971 3 12 3C9.15898 3 6.62998 4.319 4.97998 6.375"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 9.75V12C3 16.97 7.029 21 12 21C14.841 21 17.37 19.681 19.02 17.625"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.715 8.39232C14.2376 7.86962 15.0854 7.86884 15.6081 8.39232V8.39232C16.1308 8.91502 16.1308 9.76286 15.6073 10.2856L11.1164 14.7729C10.9709 14.9183 10.7734 15 10.5672 15H9V13.4327C9 13.2265 9.08167 13.029 9.22789 12.8827L13.715 8.39232V8.39232Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.6156 11.282L12.7178 9.38405"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default SvgComponent
